import { IUserLoginPayload } from '../interfaces/ILogin';

export const formatLoginPayload = (payload: IUserLoginPayload): string => {
  const email = encodeURIComponent(payload.email);
  const password = encodeURIComponent(payload.password);
  const token = payload.token ? encodeURIComponent(payload.token) : null;
  const rememberMe = payload?.rememberMe ? encodeURIComponent(payload.rememberMe) : null;

  const emailParam = `&username=${email}`;
  const passwordParam = `&password=${password}`;
  const tokenParam = token ? `&token=${token}` : '';
  const rememberMeParam = rememberMe ? `&rememberMe=${rememberMe}` : '';

  return `grant_type=password${emailParam}${passwordParam}${tokenParam}${rememberMeParam}&client_id=conversed-admin-panel`;
};

export const formatRefreshTokenPayload = (token: string): string => {
  return `grant_type=refresh_token&refresh_token=${encodeURIComponent(token)}&client_id=conversed-admin-panel`;
};
